/**
 * Created by CP.
 */
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  userType: any;

  constructor(private router: Router) {
    this.userType = JSON.parse(sessionStorage.getItem('currentUser'));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem('access_token')) {
      // logged in so return true
      return true;
    }
    if (!sessionStorage.getItem('access_token')) {
      this.router.navigate(['/public/resto']);
      sessionStorage.clear()
      location.reload()
      // logged in so return true
    //  return true;
    }

    // this.router.navigate(['/public/resto']);
    return false;
  }
}
